import { config } from '../config';
import {
	makeRequest as dnaMakeRequest,
} from 'dna-core/components/utils/js/http';

/**
 * CONSTANTS
 */

export const iamBaseHeader = {
	'Content-Type': 'application/json',
	'Accept': 'application/json',
	'Cache-Control': 'no-cache',
};

export const makeRequest = (url, action, options, deadline = config.requestTimeoutDeadline) => dnaMakeRequest(url, action, options, deadline);



// WEBPACK FOOTER //
// ../~/@jg/justgiving-app-login/app/utils/http.js